import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgSpeakerHighFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M17.5 3.527v20.94a.906.906 0 0 1-.428.784.875.875 0 0 1-.984-.06l-7.172-5.579a.438.438 0 0 1-.166-.345V8.733a.437.437 0 0 1 .17-.345l7.17-5.578a.875.875 0 0 1 1.094.017.904.904 0 0 1 .315.7ZM6.562 8.75H3.5a1.75 1.75 0 0 0-1.75 1.75v7a1.75 1.75 0 0 0 1.75 1.75h3.063A.438.438 0 0 0 7 18.812V9.188a.437.437 0 0 0-.438-.438Zm13.866 2.28a.877.877 0 0 0-.079 1.235 2.625 2.625 0 0 1 0 3.47.877.877 0 0 0 .71 1.462.875.875 0 0 0 .603-.305 4.375 4.375 0 0 0 0-5.784.875.875 0 0 0-1.237-.079h.003ZM24.9 8.166a.875.875 0 1 0-1.303 1.166 7 7 0 0 1 0 9.334.874.874 0 1 0 1.303 1.166 8.75 8.75 0 0 0 0-11.666Z" />
  </svg>
);
export default SvgSpeakerHighFill;
